import { graphql, useStaticQuery } from 'gatsby';

function useAboutUsData() {
  const data = useStaticQuery(graphql`
    {
      contentfulPage(nameid: { eq: "About Us Page" }) {
        hero_sections {
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
          primaryTitle
          primaryDescription {
            primaryDescription
          }
        }
        metaTitle
        metaDescription {
          metaDescription
        }
        whoWhyWhy: about_us___why_who_how {
          who {
            who
          }
          why {
            why
          }
          how {
            how
          }
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
          title
          title1
          title2
          title3
          align1
          align2
          align3
        }
        videoSection: video_section {
          description {
            description
          }
          subTitle
          title
          videoId
          videoUrl
          nameid
          placeholder {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
        }
        teamGrid: team_grid {
          data: team_grid_data {
            image {
              gatsbyImageData(
                quality: 100
                layout: CONSTRAINED
                placeholder: TRACED_SVG
              )
              title
            }
            description {
              description
            }
            jobTitle
            linkedIn
          }
          title
          description {
            description
          }
        }
      }
    }
  `);
  return data;
}

export default useAboutUsData;
